import { useEffect, useState } from 'preact/hooks';
import { Book, Chapter } from '../types';

// Helper to fetch a chapter from your API
const fetchChapter = async (
  book: Book,
  chapterId: number,
  chapters: Chapter[],
): Promise<Chapter> => {
  // Check the cache first
  const foundChapter = chapters.find((c) => c.id === chapterId);
  if (foundChapter && foundChapter.hydrated) {
    return foundChapter;
  }

  // Get the chapter from the API
  const url = `/api/v0/fictions/${book.id}/chapters/${chapterId}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch chapter ${chapterId}`);
  }
  const chapter = await res.json();
  chapter.hydrated = true;

  return chapter;
};

export const useChapters = (
  initialChapters: Chapter[],
  chapterPermalink: string,
  book: Book,
) => {
  const [chapters, setChapters] = useState<Chapter[]>(initialChapters);
  const [chapter, setChapter] = useState<Chapter | undefined>(undefined);
  const [nextChapter, setNextChapter] = useState<Chapter | undefined>(
    undefined,
  );
  const [prevChapter, setPrevChapter] = useState<Chapter | undefined>(
    undefined,
  );

  useEffect(() => {
    const chapter =
      chapters.find((c) => c.permalink === chapterPermalink) || undefined;

    const currentChapterIndex = chapters.findIndex((c) => c.id === chapter?.id);
    const nextChapter = chapters[currentChapterIndex + 1];
    const prevChapter = chapters[currentChapterIndex - 1];

    console.log({ chapter, nextChapter, prevChapter });

    setChapter(chapter);
    setNextChapter(nextChapter);
    setPrevChapter(prevChapter);
  }, [chapterPermalink]);

  // Fetch the chapter from the API if it's not hydrated
  useEffect(() => {
    if (chapter?.id && !chapter.hydrated) {
      console.log('gettingChapter', chapter?.id);
      fetchChapter(book, chapter.id, chapters).then((chapter) => {
        setChapters((prev) =>
          prev.map((c) => (c.id === chapter.id ? chapter : c)),
        );
        setChapter(chapter);
      });
    }
  }, [chapter?.id]);

  // Fetch the next chapter from the API
  useEffect(() => {
    console.log('gettingNextChapter', nextChapter?.id);
    if (nextChapter?.id) {
      fetchChapter(book, nextChapter.id, chapters).then((chapter) => {
        setChapters((prev) =>
          prev.map((c) => (c.id === chapter.id ? chapter : c)),
        );
        setNextChapter(chapter);
      });
    }
  }, [nextChapter?.id]);

  // Fetch the previous chapter from the API
  useEffect(() => {
    console.log('gettingPrevChapter', prevChapter?.id);
    if (prevChapter?.id) {
      fetchChapter(book, prevChapter.id, chapters).then((chapter) => {
        setChapters((prev) =>
          prev.map((c) => (c.id === chapter.id ? chapter : c)),
        );
        setPrevChapter(chapter);
      });
    }
  }, [prevChapter?.id]);

  return { chapters, chapter, nextChapter, prevChapter };
};
